import { reactive as a, readonly as d } from "vue";
import { TOAST_VISIBILITY_DURATION as u } from "../components/Toast/Toast.constant.js";
import "@vueuse/core";
import "@ds/components/Illustration";
import "@ds/components/Link";
import "@ds/components/Icon";
import "@ds/plugin";
import "@ds/tracking/tracking";
const m = 4, n = a({
  toasts: []
});
let e = 0;
function f() {
  return e += 1, `toast-${e}`;
}
function i(s, o, t = {}) {
  const r = f(), c = {
    id: r,
    title: o,
    variant: s,
    description: t.description,
    duration: t.duration ?? u,
    actionLabel: t.actionLabel,
    icon: t.icon,
    iconSrc: t.iconSrc,
    iconProps: t.iconProps,
    name: t.name,
    onAction: t.onAction,
    onClose: t.onClose
  };
  return n.toasts.length >= m && n.toasts.pop(), n.toasts.unshift(c), r;
}
function l(s) {
  const o = n.toasts.findIndex((t) => t.id === s);
  o !== -1 && n.toasts.splice(o, 1);
}
function p() {
  n.toasts.splice(0, n.toasts.length);
}
function L() {
  return {
    /**
     * The current list of active toasts (readonly)
     */
    toasts: d(n.toasts),
    /**
     * Display a success toast
     */
    success: (s, o) => i("success", s, o),
    /**
     * Display an error toast
     */
    error: (s, o) => i("error", s, o),
    /**
     * Display an info toast
     */
    info: (s, o) => i("info", s, o),
    /**
     * Remove a specific toast by ID
     */
    dismiss: l,
    /**
     * Clear all toasts
     */
    dismissAll: p
  };
}
export {
  m as MAX_TOASTS,
  L as useToast
};
